<nb-icon class="radio-button" [class.selected]="selected" [icon]="selected ? 'checkmark-circle-2-outline' : 'radio-button-off'"></nb-icon>
